import { useMutation, useQueryClient } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

import { SAVED_DASHBOARDS_QUERY_KEY } from "./useSavedDashboards";

type UpdateSavedDashboardBody = components["schemas"]["UpdateSavedDashboardBody"];
type SavedDashboardResponse = components["schemas"]["SavedDashboardResponse"];

export type UpdateSavedDashboardInput = {
  saved_dashboard_id: string;
  body: UpdateSavedDashboardBody;
};

export function useUpdateSavedDashboard() {
  const client = useApiClient();
  const queryClient = useQueryClient();
  return useMutation<SavedDashboardResponse, Error, UpdateSavedDashboardInput>({
    mutationFn: async ({ saved_dashboard_id, body }) => {
      const { data, error } = await client.PATCH(
        "/api/saved-dashboards/{saved_dashboard_id}",
        {
          params: { path: { saved_dashboard_id } },
          body,
        },
      );
      if (error !== undefined) {
        throw new Error("Failed to update saved dashboard");
      }
      return data;
    },
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: SAVED_DASHBOARDS_QUERY_KEY });
    },
  });
}
